<template>
  <el-dialog v-loading="isLoading" :center="center" :close-on-click-modal="closeOnClickModal" :width="dialogWidth" :visible="dialogVisible" top="8vh"
    :before-close="handleClose" @open="onDialogOpen">
    <template #title>
      <span class="el-dialog__title">校园信息</span>
    </template>
    <div class="backgroud-white cs-editor-content">
      <el-form key="form" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :rules="rules" :model="model" label-width="110px">
        <el-form-item label="入学日期" prop="EnrollmentDate">
          <el-date-picker align="center" size="small" format="yyyy/MM/dd" :disabled="isReadonly" v-model="model.EnrollmentDate" type="date" placeholder="请选择日期"
            class="input-width" />
        </el-form-item>
        <el-form-item label="毕业所需学分" prop="GraduationCredits">
          <el-input placeholder="请输入毕业所需学分" :disabled="isReadonly" v-model="model.GraduationCredits" oninput="value=value.replace(/[^0-9.]/g,'')"
            onblur="value=!!value?value.toNumber().toFixedEx(0):null" class="input-width" />
        </el-form-item>
        <el-form-item label="目前学分" prop="CurrentCredits">
          <el-input placeholder="请输入目前所得学分" :disabled="isReadonly" v-model="model.CurrentCredits" oninput="value=value.replace(/[^0-9.]/g,'')"
            onblur="value=!!value?value.toNumber().toFixedEx(0):null" class="input-width" />
        </el-form-item>
        <el-form-item label="目前成绩" prop="CurrentPerformance">
          <el-input placeholder="请输入CGPA" :disabled="isReadonly" v-model="model.CurrentPerformance" oninput="value=value.replace(/[^0-9.]/g,'')"
            onblur="value=!!value?value.toNumber().toFixedEx(1):null" class="input-width" />
        </el-form-item>
        <el-form-item label="预计毕业" prop="ExpectedGraduationDate">
          <el-date-picker align="center" size="small" format="yyyy/MM/dd" :disabled="isReadonly" v-model="model.ExpectedGraduationDate" type="date" placeholder="请选择日期"
            class="input-width" />
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <div class="dialog-footer popup-footer" v-if="!isReadonly">
        <el-row>
          <el-col>
            <el-button type="primary" @click="saveChanges">确认保存</el-button>
          </el-col>
        </el-row>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { mixinDevice } from "@/core/mixin";

const defaultData = {
  Id: 0,
  StudentId: 0,
  EnrollmentDate: null,
  ExpectedGraduationDate: null,
  GraduationCredits: null,
  CurrentCredits: null,
  CurrentPerformance: null,
};

const mixin_generalMethods = {
  methods: {
    validate() {
      let isValid = true;

      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.validate((valid) => {
          isValid = valid;
        });
      }

      return isValid;
    },
    getDataOut() {
      let dataOut = Object.clone(this.model);

      if (!!dataOut.EnrollmentDate)
        dataOut.EnrollmentDate = this.$moment(dataOut.EnrollmentDate).format("YYYY/MM/DD");
      if (!!dataOut.ExpectedGraduationDate)
        dataOut.ExpectedGraduationDate = this.$moment(dataOut.ExpectedGraduationDate).format("YYYY/MM/DD");
      dataOut.GraduationCredits = `${dataOut.GraduationCredits}`.toNumber();
      dataOut.CurrentCredits = `${dataOut.CurrentCredits}`.toNumber();
      dataOut.CurrentPerformance = `${dataOut.CurrentPerformance}`.toNumber();

      return dataOut;
    }
  },
};

export default {
  name: "studiesRelatedInfoEditor",
  mixins: [mixinDevice, mixin_generalMethods],
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "500px",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return Object.clone(defaultData);
      },
    },
  },
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  data() {
    return {
      isLoading: false,
      dialogVisible: false,
      rules: {
        EnrollmentDate: [
          {
            required: true,
            message: "请选择日期",
            trigger: "blur",
          },
        ],
        GraduationCredits: [
          {
            required: true,
            message: "请输入毕业所需学分",
            trigger: "blur",
          },
        ],
        CurrentCredits: [
          {
            required: true,
            message: "请输入目前所得学分",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              let fixedValue = `${value}`.toNumber();
              let fixedGraduationCredits =
                `${this.model.GraduationCredits}`.toNumber();
              if (fixedValue > fixedGraduationCredits) {
                return callback(new Error("不能大于毕业所需学分"));
              }

              return callback();
            },
            trigger: "blur",
          },
        ],
        CurrentPerformance: [
          {
            required: true,
            message: "请输入CGPA",
            trigger: "blur",
          },
        ],
        ExpectedGraduationDate: [
          {
            required: true,
            message: "请选择日期",
            trigger: "blur",
          },
        ],
      },
      model: Object.clone(defaultData),
    };
  },
  created() {
    this.reloadVisible();
  },
  computed: {
    dialogWidth() {
      return !this.isMobile() ? this.width : "100%";
    },
  },
  methods: {
    reloadModelFromDataIn() {
      if (!this.dialogVisible) return;

      this.model = Object.clone(this.data || defaultData);
      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.resetFields();
      }
    },
    reloadVisible(newValue = this.visible) {
      if (this.dialogVisible !== newValue) {
        this.dialogVisible = newValue;
      }
    },
    resetData() {
      let originalData = this.model._originalData || Object.clone(defaultData);

      Object.copy(
        this.model,
        { exceptFields: ["_originalData"] },
        originalData
      );
    },
    showDialog() {
      this.dialogVisible = true;
      this.$emit("visibleChange", this.dialogVisible);
    },
    closeDialog(needReset = false) {
      if (needReset) this.resetData();

      this.dialogVisible = false;
      this.$emit("visibleChange", this.dialogVisible);
    },
    onDialogOpen() {
      this.reloadModelFromDataIn();
    },
    handleClose(done) {
      this.closeDialog(true);
    },
    saveChanges() {
      let isValid = this.validate();
      if (!isValid) return;

      let dataOut = this.getDataOut();
      this.$emit("change", dataOut);
      this.closeDialog();
    },
  },
  watch: {
    visible(newValue) {
      this.reloadVisible(newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-editor-content {
  padding: 0 15%;
  overflow-y: auto;

  .el-form-item {
    .el-date-editor {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/academicInfo/studiesRelatedInfoEditor.vue